<script lang="ts" setup>
import {
  ITirPmUserLoginRequest,
  ITirUserResponse,
} from "@/tir-pm-authenticator/src/interfaces";
import { TirPmAutentificatiorService } from "@/tir-pm-authenticator";
import { useRoute, useRouter } from "vue-router";
import AuthLayout from "@/layouts/AuthLayout.vue";
import {
  UserIcon,
  KeyIcon,
  EyeIcon,
  EyeSlashIcon,
} from "tir-style-system/icons/outline";
import { TirPmInput } from "tir-pm-input";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";
import { TirDivider } from "tir-pm-divider";
import { computed, onBeforeUpdate, onMounted, ref, watch } from "vue";

/**
 * Дата для копирайта
 */
let today = new Date();
let year = today.getFullYear();

const route = useRoute();
/**
 * Дата для копирайта
 */

/**
 * Текущий элемент
 */
const $curentPageComponentAuth = ref(null);

/**
 * Метод для кнопки
 */
const computedMethodFromComponentRoute = computed(
  () => $curentPageComponentAuth.value?.changerMethodFromComponent
);

/**
 * Текущая высота компонента
 */
const currentHeightComponent = computed(() => {
  return $curentPageComponentAuth.value?.currentHeightComponent / 16;
});

/**
 * Состояние лоудинга в компоненте
 */
const isLoadingStateComponentComputed = computed(() => {
  return $curentPageComponentAuth.value?.isLoadingIntoComponent;
});

/**
 * Высчитать высоту блока
 */
const computeStyleHeight = computed(() => {
  return currentHeightComponent.value
    ? currentHeightComponent.value + "rem"
    : "9.375rem";
});
console.log("Имя", route.name);

/**
 * Дизейбл кнопки
 */
const isDisabledButtonFromComponent = computed(
  () => $curentPageComponentAuth.value?.validateMainButton
);
</script>

<template>
  <div class="login-auth-wrapper">
    <div class="layout-login">
      <div class="layout-login-inner">
        <router-view v-slot="{ Component }">
          <transition name="change-login-page" mode="out-in">
            <component :is="Component" ref="$curentPageComponentAuth" />
          </transition>
        </router-view>
      </div>

      <div class="layout-login__footer">
        <TirPmButton
          :size="TirPmButtonSizeEnum.Regular"
          :variant="TirPmButtonVariantEnum.PrimaryState"
          style="width: 100%"
          class="layout-login-main-button"
          @click="computedMethodFromComponentRoute"
          :isDisabled="isDisabledButtonFromComponent"
          :isLoading="isLoadingStateComponentComputed"
          test="login-btn"
        >
          <transition name="button-slide" mode="out-in">
            <span v-if="route.name == 'login'">Войти</span>
            <span v-else-if="route.name == 'restore-access'"
              >Восстановить доступ</span
            >
            <span v-else-if="route.name == 'restore-password'"
              >Сохранить и войти</span
            >
            <span v-else-if="route.name == 'restore-done'"
              >Вернуться к авторизации</span
            >
            <span v-else-if="route.name == 'activate-account'">Войти</span>
          </transition>
          <!-- <transition name="button-slide">
              <span v-if="route.name == 'restore-done'">Войти</span>
          </transition>
          <transition name="button-slide">
              <span v-if="route.name == 'login'">Войти</span>
          </transition> -->

          <!-- <span v-if="route.name == 'restore-access'"
                >Восстановить доступ</span
              > -->
        </TirPmButton>

        <!-- <TirPmButton
          :size="TirPmButtonSizeEnum.Regular"
          :variant="TirPmButtonVariantEnum.PrimaryState"
          style="width: 100%"
          @click="onRestoreAccess"
          >Восстановить доступ
        </TirPmButton> -->
        <div
          class="layout-login__footer-additional-button"
          :class="{
            'layout-login__footer-additional-button--show':
              route.name == 'login',
          }"
          v-show="route.name == 'login'"
        >
          <router-link to="/restore-access">
            <TirPmButton
              :size="TirPmButtonSizeEnum.Regular"
              :variant="TirPmButtonVariantEnum.SecondaryState"
              style="width: 100%"
              test="restore-access-btn"
              >Восстановить доступ
            </TirPmButton>
          </router-link>
        </div>
      </div>
    </div>
    <span class="login-auth-wrapper-release-sign"
      >© 2010 - {{ year }} TirScript. All rights reserved. Images
      copyright.</span
    >
  </div>
</template>

<style lang="scss">
@import "@/style/style.scss";
</style>
